<template>
  <ion-row class="title-part-padding-form-driver">
    <ion-col size="9" class="row-align-center">
      <ion-label class="title-part-form-driver">Tours</ion-label>
    </ion-col>

    <ion-col class="justify-content-end">
      <ion-button
        color="primary"
        expand="block"
        size="small"
        type="button"
        @click="$emit('add-round')"
        class="tti"
        :disabled="oldRentalCouponSending || disabled"
      >
        <ion-icon :icon="addOutline" slot="start"></ion-icon>
        Ajouter
      </ion-button>
    </ion-col>
  </ion-row>

  <ion-row class="ion-align-items-center">
    <div>
      <ion-img
        class="width-icon-img-16"
        src="/assets/icon/rounds.svg"
      ></ion-img>
    </div>

    <ion-label class="ml-5" color="medium">
      Consigne bureau&nbsp;:&nbsp;
    </ion-label>

    <ion-label v-if="rounds && rounds.name">{{ rounds.name }}</ion-label>
    <ion-label v-else>Nombre de tours non renseigné</ion-label>
  </ion-row>

  <!-- Rounds Items -->
  <template v-if="tonsByRound && Object.keys(tonsByRound).length">
    <!-- Individual Round Items -->
    <ion-item
      v-for="(entry, index) in tonsByRound"
      :key="index"
      button
      class="rounds-card"
      @click="editRound(index, entry)"
      :disabled="oldRentalCouponSending || disabled"
    >
      <ion-label>
        <h2>
          <ion-badge class="round-number">
            {{ parseInt(index) + 1 }}
          </ion-badge>
          &nbsp;
          <template v-if="entry.value">
            <strong> {{ entry.value }}</strong>
            tonnes
          </template>

          <template v-if="entry.value && getRoundMaterials(entry).length">
            de
          </template>

          <template v-if="getRoundMaterials(entry).length">
            {{ getRoundMaterials(entry).join(' + ') }}
          </template>
        </h2>

        <p
          v-if="entry.source_worksite || entry.target_worksite"
          class="row-align-center"
        >
          <template v-if="entry.source_worksite">
            <ion-icon
              class="width-icon-img-16 mr-5"
              :icon="pinOutline"
            ></ion-icon>

            {{ entry.source_worksite }}
          </template>

          <ion-icon
            v-if="entry.source_worksite && entry.target_worksite"
            class="rounds-direction"
            :icon="arrowForwardOutline"
          ></ion-icon>

          <template v-if="entry.target_worksite">
            <ion-img
              class="width-icon-img-16 mr-5"
              src="/assets/icon/pin.svg"
            />

            {{ entry.target_worksite }}
          </template>
        </p>

        <p v-if="entry.reference" class="align-line-icon-badge">
          <span v-if="entry.reference">N° Bon : {{ entry.reference }}</span>
        </p>
      </ion-label>

      <ion-button
        v-if="!oldRentalCouponSending"
        slot="end"
        class="edit-button"
        fill="clear"
        size="small"
        @click.stop="editRound(index, entry)"
        :disabled="disabled"
      >
        <ion-icon
          slot="icon-only"
          :icon="pencilOutline"
          color="dark"
        ></ion-icon>
      </ion-button>
    </ion-item>

    <!-- Total Item (if more than 1 round) -->
    <ion-item lines="none" v-if="displayTotal" class="total-item">
      <ion-label class="total-label">
        Total&nbsp;:&nbsp;<strong>{{ totalTonsByRound }} t</strong>
      </ion-label>
    </ion-item>
  </template>
</template>

<script>
import {
  IonLabel,
  IonItem,
  IonButton,
  IonIcon,
  IonImg,
  IonBadge,
} from '@ionic/vue';
import {
  addOutline,
  chevronForwardOutline,
  cubeOutline,
  pinOutline,
  arrowForwardOutline,
  pencilOutline,
} from 'ionicons/icons';
export default {
  name: 'RoundsTable',
  components: {
    IonLabel,
    IonItem,
    IonButton,
    IonIcon,
    IonImg,
    IonBadge,
  },
  props: [
    'rounds',
    'tonsByRound',
    'totalTonsByRound',

    // Read-only
    'materials',
    'oldRentalCouponSending',
    'disabled',
  ],

  emits: [
    // Data-related
    'update:rounds',
    'update:tonsByRound',

    // Other events
    'edit-round',
    'add-round',
  ],

  setup() {
    return {
      addOutline,
      chevronForwardOutline,
      cubeOutline,
      pinOutline,
      arrowForwardOutline,
      pencilOutline,
    };
  },

  methods: {
    editRound(index, entry) {
      if (this.oldRentalCouponSending || this.disabled) return;
      this.$emit('edit-round', { index, entry });
    },

    getRoundMaterials(entry) {
      // if entry has custom material, return them
      if (entry.materials && entry.materials.length > 0) {
        return entry.materials;
      }

      // else get coupon materials
      return this.materials || [];
    },
  },

  computed: {
    displayTotal() {
      // if no total or only one round, do not display the total
      if (!this.totalTonsByRound) return false;
      if (Object.keys(this.tonsByRound || {}).length <= 1) return false;

      // else, display total if every round has a value set
      return Object.values(this.tonsByRound || {}).every(
        entry =>
          entry.value !== null &&
          entry.value !== undefined &&
          entry.value !== '',
      );
    },
  },
};
</script>

<style scoped lang="scss">
.rounds-card,
.total-item {
  --padding-start: 0;
  --inner-padding-end: 0;
  margin: 8px 0;
}

.rounds-card {
  --inner-border-width: 0;
}

.edit-button {
  --padding-start: 0;
  --padding-end: 0;
}

.round-number {
  width: 22px;
  height: 22px;
  padding: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}

.rounds-direction {
  margin: 0 8px;
}
</style>
